
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components"
import Banner from "./Banner";
import { IconExpandMore } from 'cdk-radial';
import * as Styles from './styles';
import { useCampaigns } from '../../hooks/queries';
import {useAnalytics} from '../../v2/third-party-integration/amplitude';
import {AMPLITUDE_EVENTS} from '../../constants';

export default function BannerContainer() {
    const { data: campaignItems, status } = useCampaigns();
    const { darkMode } = useTheme();
    const color = darkMode ? '#1A1A1A' : '#f2f2f2';
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(true);
    const { trackEvent } = useAnalytics();

    const expandOptions = () => {
        trackEvent(AMPLITUDE_EVENTS.CAMPAIGN_ACTIONS, {'Action': 'Expand'});
        setExpanded(true);
        closetColorHandler(color);
    }

    const hideBanner = () => {
        trackEvent(AMPLITUDE_EVENTS.CAMPAIGN_ACTIONS, {'Action': 'Hide',});
        setExpanded(false);
    }

    const closetColorHandler = (color: string) => {
        // TODO: based on PO applying this fix, this will be decided later based on UX and PO sync-up, 
        // setClosetColor(color);
    }

    return (
            <>
            {status !== 'error' ?
            <Styles.PromotionWrapperSpacer data-testid="banner-container" expanded={expanded}>
            <Styles.PromotionWrapper expanded={expanded}>
                {expanded && (<Styles.PromotionBanner darkMode={darkMode}>
                    <Styles.BannerBody>
                            <Banner hideBanner={hideBanner} closetColor={closetColorHandler} bannerData={campaignItems} />
                    </Styles.BannerBody>
                </Styles.PromotionBanner>)}
            </Styles.PromotionWrapper>
            </Styles.PromotionWrapperSpacer>: null}
            <Styles.GreetingWrapperSpacer expanded={expanded}>
                <Styles.GreetingWrapper darkMode={darkMode} expanded={expanded}>
                    <Styles.GreetingBody>
                        {!expanded && <Styles.BannerOptions
                            darkMode={darkMode}
                            onClick={expandOptions}>
                            <div>{t('subHeader.discover')}</div>
                            <div><IconExpandMore darkMode={true} tabIndex={0}
                                onKeyDown={(e: any) => {
                                    e.stopPropagation();
                                    if (e.key === 'Enter') {
                                        expandOptions()
                                    }
                                }} /></div>
                        </Styles.BannerOptions>}
                    </Styles.GreetingBody>
                </Styles.GreetingWrapper>
                </Styles.GreetingWrapperSpacer>
                </>
    )
}
